import _ from '../../../../utils/underscore';
import Event from '../../../../utils/event';
import {SYSTEM_EVENTS} from '../../../../events/events';
import LaunchGameStep from './launch_gamestep_base';

export default class OpenInRedirectGameStep extends LaunchGameStep {
    static CLASS = 'OpenInRedirectGameStep';

    init(params) {
        super.init(params);
        if (!params.getGameUrlCallback) {
            this.throwArgumentExpected('12', 'init', 'getGameUrlCallback');
        }

        this._getGameUrlCallback = params.getGameUrlCallback;
        this._useSecondWebView = (_.isNullOrUndefined(params.useSecondWebView) ? true : params.useSecondWebView);
    }
    run(gameOptions) {
        return this._getGameUrlCallback(gameOptions).then(url => {

            let hybridService = this.serviceFactory.hybridService();

            if (hybridService.navigateToOnDemandStandalone(gameOptions.gameType, gameOptions.companyName, url)) {
                return gameOptions.company.getGamePostMessageListener(gameOptions).then(listener => {
                    gameOptions.gamePostMessageListener = listener;
                    return gameOptions;
                });
            } else if (this._useSecondWebView && this.serviceFactory.hybridService().isNativeSupportSecondWebView()) {
                gameOptions.isOpenedInSecondWebView = true;
                Event.fire(SYSTEM_EVENTS.WEB_VIEW_NAVIGATE_GAME, url);
            } else {
                gameOptions.isOpenedInRedirect = true;
                this.serviceFactory.windowService().redirect(url);
            }
            return gameOptions;
        });
    }
}